import React, {Component} from 'react';

import Slider from 'react-slick';

export default class PhotoSlider extends Component {
    render() {

        let settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
        };

        return (
            <Slider {...settings}>
                {this.props.children}
            </Slider>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PhotoSlider/PhotoSlider.js